import Content, {IContent} from "@/model/Content/Content"
import hasAccomodation, {IHasAccomodation} from "@/model/mixins/Accomodation/HasAccomodation"


class AccomodationContentBase extends Content {
    private accomodationName: string
    private description: string

    constructor(
        accomodationName: string,
        description: string,
    ) {
        super()
        this.accomodationName = accomodationName
        this.description = description
    }

    public getAccomodationName(): string {
        return this.accomodationName
    }
    public getDescription(): string {
        return this.description
    }
}

export interface IAccomodationContent extends AccomodationContentBase, IContent, IHasAccomodation {
    getAccomodationName(): string
    getDescription(): string
}

// apply mixins
const AccomodationContent: Constructor<IAccomodationContent> = hasAccomodation(AccomodationContentBase)

// apply 
export default AccomodationContent